import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../../index";
import { api } from "@/lib";
import { CompanyResource } from "../../../../models/api/barcodeSystem/barcodeCompanies/get";
import { BillToResource } from "../../../../models/api/barcodeSystem/billTos/get";
import { CompanyBillToResource } from "@/models/api/barcodeSystem/barcodeCompanies/billTos";
import { CompanyFacilityResource } from "@/models/api/barcodeSystem/barcodeCompanies/facilities";
import { CompanyItemTypeResource } from "@/models/api/barcodeSystem/barcodeCompanies/itemTypes";
import { CompanyManufacturerResource } from "@/models/api/barcodeSystem/barcodeCompanies/manufacturers";

const name = "barcodeCompany";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class BarcodeCompanyModule extends VuexModule {
  public loading: boolean = false;
  public error: boolean = false;
  public errorMessage: string = "";
  public companies: CompanyResource[] = null;
  public billTos: BillToResource[] = null;

  @Action
  async createCompany(payload) {
    return await api.postAsync("/barcode/companies", payload);
  }  
  
  @Action
  async updateCompany(payload) {
    return await api.putAsync(`/barcode/companies/${payload.id}`, payload);
  }

  @Action
  async deleteCompany(id) {
    return await api.deleteAsync(`/barcode/companies/${id}`);
  }

  @Action
  async addCompanyFacilityCode(payload) {
    return await api.postAsync(`/barcode/companies/${payload.id}/facilities`, payload);
  }

  @Action
  async removeCompanyFacilityCode(payload) {
    return await api.deleteAsync(`/barcode/companies/${payload.id}/facilities/${payload.facilityCode}`);
  }

  @Action
  async addCompanyManufacturer(payload) {
    return await api.postAsync(`/barcode/companies/${payload.id}/manufacturers`, payload);
  }

  @Action
  async removeCompanyManufacturer(payload) {
    return await api.deleteAsync(`/barcode/companies/${payload.id}/manufacturers/${payload.manufacturerCode}`);
  }  
  
  @Action
  async addCompanyItemType(payload) {
    return await api.postAsync(`/barcode/companies/${payload.id}/itemTypes`, payload);
  }

  @Action
  async removeCompanyItemType(payload) {
    return await api.deleteAsync(`/barcode/companies/${payload.id}/itemTypes/${payload.itemTypeValue}`);
  }
  
  @Action
  async addCompanyBillTo(payload) {
    return await api.postAsync(`/barcode/companies/${payload.id}/billtos`, payload);
  }

  @Action
  async removeCompanyBillTo(payload) {
    return await api.deleteAsync(`/barcode/companies/${payload.id}/billtos/${payload.billToCompanyId}`);
  }

  @Action
  async getCompanies() {
    return await api.getAsync("/barcode/companies?sortField=companyname");
  }   

  @Action
  async getBillTos() {
    return await api.getAsync("/barcode/billTos");
  }   
  
  @Action
  async getCompany(id: number) {
    var response = await api.getAsync(`/barcode/companies/${id}`);
    return response.data;
  } 
  
  @Action
  async getCompanyBillTos(id: number) : Promise<CompanyBillToResource[]> {
    var response = await api.getAsync(`/barcode/companies/${id}/billTos`);
    return response.data;
  }  

  @Action
  async getCompanyFacilities(id: number) : Promise<CompanyFacilityResource[]> {
    var response = await api.getAsync(`/barcode/companies/${id}/facilities`);
    return response.data;
  } 
  
  @Action
  async getCompanyManufacturers(id: number) : Promise<CompanyManufacturerResource[]> {
    var response = await api.getAsync(`/barcode/companies/${id}/manufacturers`);
    return response.data;
  } 

  @Action
  async getCompanyItemTypes(id: number) : Promise<CompanyItemTypeResource[]> {
    var response = await api.getAsync(`/barcode/companies/${id}/itemTypes`);
    return response.data;
  } 

  @Action
  async loadCompanies(): Promise<void> {
    const response = await this.getCompanies();
    this.setCompanies(response.data);
  }

  @Mutation
  setCompanies(companies: CompanyResource[]) {
    this.companies = companies;
  }

  @Action
  async loadBillTos(): Promise<void> {
    const response = await this.getBillTos();
    this.setBillTos(response.data);
  }

  @Mutation
  setBillTos(billTos: BillToResource[]) {
    this.billTos = billTos;
  }
}
